import React from 'react';
import PropTypes from 'prop-types';
import RefreshIndicator from 'material-ui/RefreshIndicator';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import ContentAdd from 'material-ui/svg-icons/content/add';
import classes from './ActionButton.scss';

class ActionButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      loadingTimer: null,
      loading: false,
    };

    this.timer = null;
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.fetchingTask === true ||
      nextProps.fetchingCompany === true ||
      nextProps.fetchingActivity === true ||
      nextProps.fetchingPerson === true ||
      nextProps.fetchingProject === true ||
      nextProps.fetchingNote === true ||
      nextProps.fetchingStaff === true ||
      nextProps.fetchingNotification === true
    ) {
      this.setState({
        loading: true,
      });

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(() => {
        this.stopTimer();
      }, 3000);
    }
  }

  stopTimer = () => {
    this.setState({
      loading: false,
    });
  };

  handleTouchTap = event => {
    // This prevents ghost click.
    event.preventDefault();

    this.setState({
      open: true,
      anchorEl: event.currentTarget,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  renderIndicator = () => {
    if (this.state.loading) {
      return (
        <div className={classes.indicator}>
          <RefreshIndicator
            size={20}
            left={0}
            top={0}
            loadingColor="#4a90e2"
            status="loading"
          />
        </div>
      );
    }
    return null;
  };

  checkIfWithinLimits = (
    resource,
    action,
    resourceName,
    actionParam = null,
  ) => {
    if (this.props.limits[`${resource}Left`] > 0) {
      // its okay, more than enough left
      // console.log('within limits');
      action(actionParam);
    } else {
      // can't execute, no resources left
      // console.log('not within limits');
      this.props.addFeedback(
        'error',
        `Sie können keine weiteren ${resourceName} anlegen.
      Löschen Sie bestehende oder wechseln Sie auf einen größeren SiMPL Plan`,
      );
    }
  };
  clickedFab = () => {
    const pathname = window.location.pathname;
    if (pathname.match(/^\/activity\/?$/)) {
      this.checkIfWithinLimits(
        'activities',
        this.props.setActivityForm,
        'Aktivitäten',
      );
    } else if (pathname.match(/^\/company\/?$/)) {
      this.checkIfWithinLimits(
        'companies',
        this.props.setCompanyForm,
        'Unternehmen',
      );
    } else if (pathname.match(/^\/project\/?$/)) {
      this.checkIfWithinLimits(
        'projects',
        this.props.setProjectForm,
        'Projekte',
      );
    } else if (
      pathname.match(/^\/staff\/?$/) ||
      pathname.match(/^\/user\/?$/)
    ) {
      this.checkIfWithinLimits('staff', this.props.setStaffForm, 'Mitarbeiter');
    } else if (pathname.match(/^\/person\/?$/)) {
      this.checkIfWithinLimits('persons', this.props.setPersonForm, 'Kontakte');
    } else if (pathname.match(/^\/serviceKey\/?/)) {
      this.props.setServiceKeyForm();
    } else if (pathname.match(/^\/numberrange\/?/)) {
      this.props.setNumberRangeForm();
    }
  };
  getAdditionalButtons = () => {
    const additionalButtons = [];
    const pathname = window.location.pathname;
    if (pathname.match(/^\/company\//)) {
      additionalButtons.push(
        <MenuItem
          key="new_activity"
          primaryText="Neue Aktivität"
          onClick={() => {
            this.handleRequestClose();
            window.simplPreselection.company = this.props.currentCompany;
            this.checkIfWithinLimits(
              'activities',
              this.props.setActivityForm,
              'Aktivitäten',
            );
          }}
        />,
      );
      additionalButtons.push(
        <MenuItem
          key="new_project"
          primaryText="Neues Projekt"
          onClick={() => {
            this.handleRequestClose();
            window.simplPreselection.company = this.props.currentCompany;
            this.checkIfWithinLimits(
              'projects',
              this.props.setProjectForm,
              'Projekte',
            );
          }}
        />,
      );
      additionalButtons.push(
        <MenuItem
          key="new_person"
          primaryText="Neuer Kontakt"
          onClick={() => {
            this.handleRequestClose();
            window.simplPreselection.company = this.props.currentCompany;
            this.checkIfWithinLimits(
              'persons',
              this.props.setPersonForm,
              'Kontakte',
            );
          }}
        />,
      );
    } else if (pathname.match(/^\/project\//)) {
      additionalButtons.push(
        <MenuItem
          key="new_activity"
          primaryText="Neue Aktivität"
          onClick={() => {
            this.handleRequestClose();
            window.simplPreselection.project = this.props.currentProject;
            this.checkIfWithinLimits(
              'activities',
              this.props.setActivityForm,
              'Aktivitäten',
            );
          }}
        />,
        <MenuItem
          key="new_project"
          primaryText="Neues Unterprojekt"
          onClick={() => {
            this.handleRequestClose();
            window.simplPreselection.project = this.props.currentProject;
            this.checkIfWithinLimits(
              'projects',
              this.props.setProjectForm,
              'Projekte',
            );
          }}
        />,
        <MenuItem
          key="project_blueprint"
          primaryText="Projekt als Vorlage nutzen"
          onClick={() => {
            this.handleRequestClose();
            window.simplPreselection.usAsBlueprint = true;

            this.checkIfWithinLimits(
              'projects',
              this.props.setProjectForm,
              'Projekte',
              this.props.currentProject,
            );
          }}
        />,
      );
    } else if (pathname.match(/^\/person\//)) {
      additionalButtons.push(
        <MenuItem
          key="new_activity"
          primaryText="Neue Aktivität"
          onClick={() => {
            this.handleRequestClose();
            window.simplPreselection.person = this.props.currentPerson;
            this.checkIfWithinLimits(
              'activities',
              this.props.setActivityForm,
              'Aktivitäten',
            );
          }}
        />,
      );
    } else if (pathname.match(/^\/staff\//) || pathname.match(/^\/user\//)) {
      additionalButtons.push(
        <MenuItem
          key="new_activity"
          primaryText="Neue Aktivität"
          onClick={() => {
            this.handleRequestClose();
            window.simplPreselection.staff = this.props.currentStaff;
            this.checkIfWithinLimits(
              'activities',
              this.props.setActivityForm,
              'Aktivitäten',
            );
          }}
        />,
      );
    } else if (pathname.match(/^\/dashboard/)) {
      additionalButtons.push(
        <MenuItem
          key="new_activity"
          primaryText="Neue Aktivität"
          onClick={() => {
            this.handleRequestClose();
            this.checkIfWithinLimits(
              'activities',
              this.props.setActivityForm,
              'Aktivitäten',
            );
          }}
        />,
      );
      additionalButtons.push(
        <MenuItem
          key="new_company"
          primaryText="Neues Unternehmen"
          onClick={() => {
            this.handleRequestClose();
            this.checkIfWithinLimits(
              'companies',
              this.props.setCompanyForm,
              'Unternehmen',
            );
          }}
        />,
      );
      additionalButtons.push(
        <MenuItem
          key="new_project"
          primaryText="Neues Projekt"
          onClick={() => {
            this.handleRequestClose();
            this.checkIfWithinLimits(
              'projects',
              this.props.setProjectForm,
              'Projekte',
            );
          }}
        />,
      );
      additionalButtons.push(
        <MenuItem
          key="new_person"
          primaryText="Neuer Kontakt"
          onClick={() => {
            this.handleRequestClose();
            this.checkIfWithinLimits(
              'persons',
              this.props.setPersonForm,
              'Kontakte',
            );
          }}
        />,
      );
    }
    return additionalButtons;
  };
  render() {
    const props = this.props;
    if (this.props.token === null) {
      return <div />;
    }
    let fabVisible = true;
    let fabSolo = false;
    let fab = null;
    let additionalButtons = null;
    const openClass = props.sidebarOpen
      ? classes.statusbarOpen
      : classes.statusbarClosed;
    const statusbarClass = `${classes.statusbar} ${openClass}`;
    const pathname = window.location.pathname;
    if (pathname.match(/^\/activity\/?$/)) {
      fabSolo = true;
    } else if (pathname.match(/^\/company\/?$/)) {
      fabSolo = true;
    } else if (pathname.match(/^\/project\/?$/)) {
      fabSolo = true;
    } else if (
      pathname.match(/^\/staff\/?$/) ||
      pathname.match(/^\/user\/?$/)
    ) {
      fabSolo = true;
    } else if (pathname.match(/^\/person\/?$/)) {
      fabSolo = true;
    } else if (pathname.match(/^\/serviceKey\/?/)) {
      fabSolo = true;
    } else if (pathname.match(/^\/numberrange\/?/)) {
      fabSolo = true;
    } // detail views
    if (pathname.match(/^\/activity\//)) {
      // TODO: Add Button For New Task in Activity
      fabVisible = false;
    }
    if (pathname.match(/^\/recovery/)) {
      // TODO: Add Button For New Task in Activity
      fabVisible = false;
    }
    if (fabVisible) {
      if (!fabSolo) {
        additionalButtons = this.getAdditionalButtons();
        fab = (
          <FloatingActionButton onMouseDown={this.handleTouchTap}>
            <ContentAdd />
          </FloatingActionButton>
        );
      } else {
        fab = (
          <FloatingActionButton onMouseDown={this.clickedFab}>
            <ContentAdd />
          </FloatingActionButton>
        );
      }
    }
    let popOver = null;
    if (this.state.open) {
      popOver = (
        <Popover
          open={this.state.open}
          anchorEl={this.state.anchorEl}
          anchorOrigin={{
            horizontal: 'right',
            vertical: 'top',
          }}
          targetOrigin={{
            horizontal: 'right',
            vertical: 'bottom',
          }}
          onRequestClose={this.handleRequestClose}
        >
          <Menu>{additionalButtons}</Menu>
        </Popover>
      );
    }
    return (
      <div className={`${statusbarClass} JoyrideStep1`}>
        <div className={classes.buttonWrapper}>
          {fab}
          {popOver}
        </div>
        {this.renderIndicator()}
      </div>
    );
  }
}
ActionButton.propTypes = {
  addFeedback: PropTypes.func.isRequired,
  fetchingTask: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  fetchingCompany: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  fetchingProject: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  fetchingActivity: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  fetchingPerson: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  fetchingStaff: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  fetchingNote: PropTypes.bool.isRequired, // eslint-disable-line react/no-unused-prop-types
  fetchingNotification: PropTypes.bool, // eslint-disable-line react/no-unused-prop-types
  setActivityForm: PropTypes.func.isRequired,
  setCompanyForm: PropTypes.func.isRequired,
  setProjectForm: PropTypes.func.isRequired,
  setStaffForm: PropTypes.func.isRequired,
  setPersonForm: PropTypes.func.isRequired,
  setServiceKeyForm: PropTypes.func.isRequired,
  setNumberRangeForm: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
  token: PropTypes.string,
  currentCompany: PropTypes.string,
  currentProject: PropTypes.string,
  currentPerson: PropTypes.string,
  currentStaff: PropTypes.string,
  limits: PropTypes.object.isRequired,
};
ActionButton.defaultProps = {
  token: null,
  fetchingTask: false,
  fetchingCompany: false,
  fetchingProject: false,
  fetchingActivity: false,
  fetchingPerson: false,
  fetchingStaff: false,
  fetchingNote: false,
  fetchingNotification: false,
};

export default ActionButton;



// WEBPACK FOOTER //
// ./src/components/ActionButton/component.js